import * as React from 'react';

import { boxBlue, purpleRain } from '../../styles/variables';
import AccessibleSVG from '../accessible-svg';

var IconMetadataColored = function IconMetadataColored(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        color = _ref.color,
        title = _ref.title,
        type = _ref.type,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 16 : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 16 : _ref$height;

    var fill = void 0;

    if (color) {
        fill = color;
    } else if (type === 'cascade') {
        fill = purpleRain;
    } else if (type === 'default') {
        fill = boxBlue;
    } else {
        fill = boxBlue;
    }

    return React.createElement(
        AccessibleSVG,
        {
            className: 'icon-metadata ' + className,
            title: title,
            width: width,
            height: height,
            viewBox: '0 0 16 16'
        },
        React.createElement('path', {
            className: 'fill-color',
            d: 'M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm-2.515-5.879L6.2 7.263l1.376 2.202a.5.5 0 0 0 .848 0L9.8 7.263l.715 2.858a.5.5 0 0 0 .97-.242l-1-4a.5.5 0 0 0-.909-.144L8 8.257 6.424 5.735a.5.5 0 0 0-.91.144l-1 4a.5.5 0 0 0 .971.242z',
            fill: fill,
            fillRule: 'evenodd'
        })
    );
};

IconMetadataColored.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    type: PropTypes.oneOf(['cascade', 'default']),
    width: PropTypes.number,
    height: PropTypes.number
};
export default IconMetadataColored;
import PropTypes from 'prop-types';